import { ThemeParameters, RuntimeThemeParameters } from '../../types';
import { maxLumaContrast, relativeLuminance } from '../util';
import { graphDataStyle, graphOutlines, graphWallFill } from './';

export const graphOutlinesUnfilled = (
  theme: ThemeParameters,
  parameters: RuntimeThemeParameters
) => {
  return {
    lineColor: relativeLuminance(
      maxLumaContrast(
        [
          graphDataStyle.style1(theme, parameters).altColor,
          graphDataStyle.style2(theme, parameters).altColor,
          graphDataStyle.style3(theme, parameters).altColor,
          graphDataStyle.style4(theme, parameters).altColor,
          graphDataStyle.style5(theme, parameters).altColor,
          graphDataStyle.style6(theme, parameters).altColor,
          graphDataStyle.style7(theme, parameters).altColor,
          graphDataStyle.style8(theme, parameters).altColor,
        ],
        graphWallFill(theme, parameters).fillColor
      )
    ),
    lineStyle: graphOutlines(theme, parameters).lineStyle,
    lineThickness: graphOutlines(theme, parameters).lineThickness,
  };
};
